module.exports = __webpack_public_path__ + "img/1496530143.8b1a3277.jpg";